import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

const Step0Home = () => {
    const { mockUser } = useOutletContext();
    const navigate = useNavigate();

    // Determine status based on currentStep
    const isRegistrationComplete = true; // Always true if they can see this page
    const isAppFormComplete = mockUser.currentStep >= 12; // Assuming 12 is final submit
    const isFeePaid = false; // Mock flow doesn't have payment yet

    return (
        <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
            <h4>Current Status</h4>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <tbody>
                        <tr style={{ fontWeight: 'bold' }}>
                            <th style={{ width: '50%' }}>Registration Form</th>
                            <th style={{ width: '50%' }}>
                                <i className="fa fa-check-circle" style={{marginRight:'5px'}}></i>
                                <span style={{ color: 'Green' }}>Completed</span>
                            </th>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                            <th style={{ width: '50%' }}>Application Form</th>
                            <th style={{ width: '50%' }}>
                                {isAppFormComplete ? (
                                    <>
                                        <i className="fa fa-check-circle" style={{marginRight:'5px'}}></i>
                                        <span style={{ color: 'Green' }}>Completed</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-clock-o" style={{marginRight:'5px'}}></i>
                                        <span style={{ color: 'Orange' }}>Incomplete</span>
                                    </>
                                )}
                            </th>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                            <th style={{ width: '50%' }}>Fee Payment</th>
                            <th style={{ width: '50%' }}>
                                {isFeePaid ? (
                                    <>
                                        <i className="fa fa-check-circle" style={{marginRight:'5px'}}></i>
                                        <span style={{ color: 'Green' }}>Completed</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-clock-o" style={{marginRight:'5px'}}></i>
                                        <span style={{ color: 'Orange' }}>Incomplete</span>
                                    </>
                                )}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="contentmiddiv" style={{ marginTop: '20px' }}>
                <div className="row">
                    <div className="ins-wrapper" style={{background:'#dff0d8', padding:'15px', border:'1px solid #d6e9c6', borderRadius:'4px', color:'#3c763d'}}>
                        <p className="text-left fs18" style={{margin:0}}>
                            Your registration for Common University Entrance Test is complete. Your application form will remain incomplete till you fill all the fields of application form and pay the fee. Please note down the Application No. for future references.
                        </p>
                    </div>

                    <p className="text-center fs18" style={{ marginTop: '20px', fontSize:'18px', fontWeight:'bold' }}>
                        Application Number : <span className="text-primary">{mockUser.applicationNo}</span>
                    </p>

                    {!isAppFormComplete && (
                        <>
                            <p className="text-center fs18" style={{marginTop:'10px'}}>
                                Kindly complete the application form by clicking on the button below.
                            </p>
                            <div className="form-group">
                                <div className="col-sm-12 text-center">
                                    <button 
                                        className="btn btn-primary btn-lg" 
                                        onClick={() => navigate('/services/counselling/dashboard/contact-details')}
                                        style={{marginTop:'10px'}}
                                    >
                                        Fill Up Application Form
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            

        </div>
    );
};

export default Step0Home;